import React, { useState, useEffect } from "react";
import MuiStepper from "../components/stepper/MuiSteper";
import Submit from "../pages/submit/Submit";
import ClinicInfo from "./ClinicInfo";
import PatientInfo2 from "./PatientInfo2";
import SimpleCartReview from "./SimpleCartReview";
import apiClient from "../common/apiClient";
import MultipleLinerSelection from "./MultipleLinerSelection";
import AccountNumberPage from "./AccountNumberPage";
import MultiProductController from "./MultiProductController"
import MultipleFootSelection from "./MultipleFootSelection";
import { GetAccountPermission } from "../common/common";
import { CloseNotification } from "../components/notification/Notification";

const FootBundle = (props) => {
  const [activeInnerStep, setActiveInnerStep] = useState(0);
  const [activeOuterStep, setActiveOuterStep] = useState(0);
  const [open, setOpen] = useState(false);
  const [showSubmit, setShowSubmit] = useState(true);
  const [cart, setCart] = useState(Array(0));
  const [tempCart, setTempCart] = useState(Array(0));
  const [openClear, setOpenClear] = useState(false);
  const [showClear, setShowClear] = useState(true);
  const [formTypeIdsToAdd, setFormTypeIdsToAdd] = useState([]);
  const [isReady, setIsReady] = useState(false);
  const [formData, setFormData] = useState([]);
  const [updateCartEditor, setUpdateCartEditor] = useState(false);

  const formTypeId = 15;

  const loadCart = async () => {
    setTempCart([]);

    const currentAddedFormTypeIDs = await productsAdded();
    props.setMultiProductCart(currentAddedFormTypeIDs);

    let currentBasket = null;
    let isMulti = null

    if (currentAddedFormTypeIDs) {
      currentBasket = await getProductBasket(formTypeId)
      isMulti = true
    }

    try {
      const response = await apiClient.get(
        `cart/${formTypeId}?isMulti=${isMulti}&basketId=${currentBasket?.id}`
      )

      setCart(response.data);

      await loadData();
    } catch (error) {
      console.log(error)
    };
  }

  const joinedCart = () => {
    let uniqueMainCart = cart.filter(c => !tempCart.some(t => t.sourceId?.toLowerCase() === c.sourceId?.toLowerCase() || t.name === c.name));

    return uniqueMainCart.concat(tempCart);
  }

  const handleNext = async () => {
    await loadCart();
    const currentFormData = await getFormData()
    if (activeOuterStep === currentFormData.length - 1) {
      return;
    } else {
      setActiveOuterStep(activeOuterStep + 1);
      setActiveInnerStep(0);
    }
  };

  const handleBack = async () => {
    CloseNotification();
    await loadCart();
    if (activeOuterStep === 0) {
      return;
    } else {
      setActiveOuterStep(activeOuterStep - 1);
    }
  };

  const handleClearBack = () => {
    loadCart();
    setActiveOuterStep(0);
    setActiveInnerStep(0);
    setUpdateCartEditor(true);
  };

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setShowSubmit(true);
  };

  const handleClickClearOpen = () => {
    setOpenClear(true);
  };

  const handleCloseClear = () => {
    setOpenClear(false);
    setShowClear(true);
  };

  const getFormData = async () => {
    let isMulti = null;
    let currentIds = null;
    const currentAddedFormTypeIDs = await productsAdded()
    if (currentAddedFormTypeIDs) {
      currentIds = currentAddedFormTypeIDs.split(",");
      setFormTypeIdsToAdd(currentIds);
      isMulti = true
    }

    let baseFormData = []
    if (!isMulti) {
      baseFormData = await defaultFormData();
    } else {
      baseFormData = await addFormData(currentIds, true)
    }
    setFormData(baseFormData);
    return baseFormData;
  }

  const loadData = async () => {
    try {
      const currentAddedFormTypeIDs = await productsAdded()

      if (currentAddedFormTypeIDs) {
        const currentIds = currentAddedFormTypeIDs.split(",");
        setFormTypeIdsToAdd(currentIds);
        addFormData(currentIds)
      }

    } catch (error) {
      console.log(error);
    }
  }

  const removeProduct = async (formType) => {
    const formTypeIdToRemove = formType.formContent.props.formTypeId;

    try {
      const { data } = await apiClient.delete(`multiProduct/${formTypeId}?formTypeIdToDelete=${formTypeIdToRemove}`);

      return data;
    }
    catch (error) {
      console.log(error)
    }
  }

  const getProductBasket = async (formTypeId) => {
    try {
      const { data } = await apiClient.get("multiProduct/" + formTypeId);

      return data;
    }
    catch (error) {
      console.log(error)
    }
  }

  const addFormData = async (ids) => {
    let initialFormData = null;

    if (ids.length === 0) {
      initialFormData = await defaultFormData()
    } else {
      let indexToAppend = null;
      initialFormData = await defaultFormData()
      ids.forEach(id => {

        indexToAppend = initialFormData.findIndex(f => f.name === "Add Product");
        const maxId = initialFormData[initialFormData.length - 1].id;

        let productToAdd = null;

        if (parseInt(id) === 15) {
          productToAdd = {
            id: maxId + 1,
            name: "Feet",
            innerSteps: [],
            formContent: (
              <MultipleFootSelection
                formTypeId={15}
                handleNext={handleNext}
                handleBack={handleBack}
                handleClickOpen={handleClickOpen}
                handleClose={handleClose}
                showSubmit={showSubmit}
                setShowSubmit={setShowSubmit}
                open={open}
                setTempCart={setTempCart}
                loadCart={loadCart}
                handleClearBack={handleClearBack}
                handleClickClearOpen={handleClickClearOpen}
                handleCloseClear={handleCloseClear}
                showClear={showClear}
                setShowClear={setShowClear}
                openClear={openClear}
                isMulti={true}
                parentFormTypeId={formTypeId}
                productsAdded={productsAdded}
                removeProduct={removeProduct}
                getFormData={getFormData}
                formTypeIdsToAdd={formTypeIdsToAdd}
                setFormTypeIdsToAdd={setFormTypeIdsToAdd}
                getProductBasket={getProductBasket}
                updateCartEditor={updateCartEditor}
                setUpdateCartEditor={setUpdateCartEditor}
              />
            ),
          }
        } else if (parseInt(id) === 14) {
          productToAdd = {
            id: maxId + 1,
            name: "Liner",
            innerSteps: [],
            formContent: (
              <MultipleLinerSelection
                formTypeId={14}
                handleNext={handleNext}
                handleBack={handleBack}
                handleClickOpen={handleClickOpen}
                handleClose={handleClose}
                showSubmit={showSubmit}
                setShowSubmit={setShowSubmit}
                open={open}
                setTempCart={setTempCart}
                loadCart={loadCart}
                handleClearBack={handleClearBack}
                handleClickClearOpen={handleClickClearOpen}
                handleCloseClear={handleCloseClear}
                showClear={showClear}
                setShowClear={setShowClear}
                openClear={openClear}
                isMulti={true}
                parentFormTypeId={formTypeId}
                productsAdded={productsAdded}
                removeProduct={removeProduct}
                getFormData={getFormData}
                formTypeIdsToAdd={formTypeIdsToAdd}
                setFormTypeIdsToAdd={setFormTypeIdsToAdd}
                getProductBasket={getProductBasket}
                updateCartEditor={updateCartEditor}
                setUpdateCartEditor={setUpdateCartEditor}
              />
            ),
          }
        }

        if (productToAdd) {
          initialFormData.splice(indexToAppend, 0, productToAdd);
        }

      })
      // remove the add product controller because products already selected
      initialFormData = initialFormData.filter(ifd => ifd.name !== 'Add Product');
    }

    setFormData(initialFormData);
    return initialFormData;
  }

  const productsAdded = async () => {
    let accountNumber = localStorage.getItem("accountNumber");

    let parentAccountNumber = localStorage.getItem("parentAccount");
    if (parentAccountNumber) {
      accountNumber = parentAccountNumber;
    }

    const hasMultiProductPermission = await GetAccountPermission(accountNumber, "MULTI_PRODUCT_LINERS");
    
    if (!hasMultiProductPermission) {
      return "";
    }

    let config = {};

    config.params = {
      fieldNames: [
        "AddedFormTypeIDs"
      ],
    };

    const result = await apiClient.get(
      "fieldInputs/" + formTypeId,
      config
    )

    let currentAddedFormTypeIDs = result?.data?.find((fi) => fi.fieldName === "AddedFormTypeIDs")?.stringData ?? "";
    return currentAddedFormTypeIDs;
  }

  const defaultFormData = async () => {
    let items = [];
    let isMulti = null;
    const currentAddedFormTypeIDs = await productsAdded()
    if (currentAddedFormTypeIDs) {
      isMulti = true;
    }

    if (localStorage.getItem("internalAccount")) {
      items.push({
        id: 0,
        name: "Account Number",
        formContent: (
          <AccountNumberPage
            setActiveInnerStep={setActiveInnerStep}
            formTypeId={formTypeId}
            handleNext={handleNext}
            handleBack={handleBack}
            handleClickOpen={handleClickOpen}
            handleClose={handleClose}
            showSubmit={showSubmit}
            setShowSubmit={setShowSubmit}
            open={open}
            setTempCart={setTempCart}
            loadCart={loadCart}
            handleClearBack={handleClearBack}
            handleClickClearOpen={handleClickClearOpen}
            handleCloseClear={handleCloseClear}
            showClear={showClear}
            setShowClear={setShowClear}
            openClear={openClear}
            isMulti={isMulti}
          />
        )
      })
    }

    items.push(...[
      {
        id: 4,
        name: "Feet",
        innerSteps: [],
        formContent: (
          <MultipleFootSelection
            formTypeId={formTypeId}
            handleNext={handleNext}
            handleBack={handleBack}
            handleClickOpen={handleClickOpen}
            handleClose={handleClose}
            showSubmit={showSubmit}
            setShowSubmit={setShowSubmit}
            handleClearBack={handleClearBack}
            handleClickClearOpen={handleClickClearOpen}
            handleCloseClear={handleCloseClear}
            open={open}
            showClear={showClear}
            setShowClear={setShowClear}
            openClear={openClear}
            setTempCart={setTempCart}
            loadCart={loadCart}
            isMulti={isMulti}
            parentFormTypeId={formTypeId}
            productsAdded={productsAdded}
            getProductBasket={getProductBasket}
            updateCartEditor={updateCartEditor}
            setUpdateCartEditor={setUpdateCartEditor}
          />
        ),
      }
    ])

    let accountNumber = localStorage.getItem("accountNumber");

    let parentAccountNumber = localStorage.getItem("parentAccount");
    if (parentAccountNumber) {
      accountNumber = parentAccountNumber;
    }

    const hasMultiProductPermission = await GetAccountPermission(accountNumber, "MULTI_PRODUCT_LINERS")

    if (hasMultiProductPermission) {
      items.push(...[
        {
          id: 5,
          name: "Add Product",
          innerSteps: [],
          formContent: (
            <MultiProductController
              addFormData={addFormData}
              handleNext={handleNext}
              handleBack={handleBack}
              setFormTypeIdsToAdd={setFormTypeIdsToAdd}
              formTypeIdsToAdd={formTypeIdsToAdd}
              setActiveOuterStep={setActiveOuterStep}
              getFormData={getFormData}
              formTypeId={formTypeId}
              removeProduct={removeProduct}
              isMulti={isMulti}
              productsAdded={productsAdded}
              parentFormTypeId={formTypeId}
              handleClearBack={handleClearBack}
              handleClickClearOpen={handleClickClearOpen}
              handleCloseClear={handleCloseClear}
              open={open}
              showClear={showClear}
              setShowClear={setShowClear}
              openClear={openClear}
            />
          ),
        }
      ])
    }

    items.push(...[
      {
        id: 6,
        name: "Customer information",
        innerSteps: [],
        formContent: (
          <ClinicInfo
            formTypeId={formTypeId}
            handleNext={handleNext}
            handleBack={handleBack}
            handleClickOpen={handleClickOpen}
            handleClose={handleClose}
            showSubmit={showSubmit}
            setShowSubmit={setShowSubmit}
            open={open}
            setTempCart={setTempCart}
            loadCart={loadCart}
            handleClearBack={handleClearBack}
            handleClickClearOpen={handleClickClearOpen}
            handleCloseClear={handleCloseClear}
            showClear={showClear}
            setShowClear={setShowClear}
            openClear={openClear}
            isMulti={isMulti}
          />
        ),
      },

      {
        id: 7,
        name: "Shipping Information",
        innerSteps: [],
        formContent: (
          <PatientInfo2
            formTypeId={formTypeId}
            handleNext={handleNext}
            handleBack={handleBack}
            handleClickOpen={handleClickOpen}
            handleClose={handleClose}
            showSubmit={showSubmit}
            setShowSubmit={setShowSubmit}
            open={open}
            setTempCart={setTempCart}
            loadCart={loadCart}
            handleClearBack={handleClearBack}
            handleClickClearOpen={handleClickClearOpen}
            handleCloseClear={handleCloseClear}
            showClear={showClear}
            setShowClear={setShowClear}
            openClear={openClear}
            isMulti={isMulti}
          />
        ),
      },

      {
        id: 8,
        name: "Order Review",
        innerSteps: [],
        formContent: (
          <SimpleCartReview
            formTypeId={formTypeId}
            handleNext={handleNext}
            handleBack={handleBack}
            formName="Feet"
            isMulti={isMulti}
            parentFormTypeId={formTypeId}
          />
        ),
      },

      {
        id: 9,
        name: "Submit",
        innerSteps: [],
        formContent: <Submit />,
      },
    ]);
    return items;
  }

  const totalIds = () => formData.reduce((count) => {
    return count + 1;
  }, 0);

  useEffect(() => {
    const getInitialCart = async () => {
      await loadCart();
    }

    getInitialCart()
  }, [])

  useEffect(() => {
    const getInitialFormData = async () => {
      await getFormData()
      setIsReady(true)
    }
    getInitialFormData()
  }, [activeOuterStep, openClear, showClear, showSubmit, open])

  return (
    !isReady ? <></> :
      <>
        <div style={{ display: "flex", width: "100%" }}>
          <MuiStepper
            data={formData}
            innerStep={activeInnerStep}
            setInnerStep={setActiveInnerStep}
            setActiveOuterStep={setActiveOuterStep}
            activeOuterStep={activeOuterStep}
            formName="Feet"
            totalSteps={totalIds}
            cart={joinedCart()}
          />
        </div>
      </>
  );
};

export default FootBundle;